import DialogAlertErrorSimple from "components/DialogAlertErrorSimple/v2";

const DialogErrorForFutureReservationsInDesactivate = ({ dialog }) => {
	return (
		<DialogAlertErrorSimple
			dialog={dialog}
			title="No se puede desactivar el espacio"
			content="Actualmente el espacio cuenta con reservas, para desactivarlo, debes validar que no exista ninguna reserva vigente o futura." />
	);
}

export default DialogErrorForFutureReservationsInDesactivate;